import React, { useEffect, useState, useRef } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Link,
} from "react-router-dom";
import Sidebar from "./components/Sidebar.js";
import Navbar from "./components/Navbar.js";
import ActiveInsurence from "./pages/ActiveInsurence";
import Login from "./pages/Login.js";
import Summery from "./pages/Summery";
import LoginScreenOne from "./pages/Login-otp.js";
import LoginScreenTwo from "./pages/Login-success.js";
import SignUp from "./pages/SignUp.js";
import ProfilePage from "./pages/ProfilePage.js";
import PrivateRoute from "./components/PrivateRoute.js";
import FinancePension from "./pages/FinancePension.js";
import FinancePensionWithChart from "./pages/FinancePensionWithChart.js";
import SummaryPage from "./pages/SummaryPage.js";
import LoadingPage from "./pages/LoadingPage.js";
import RetirementPage from "./pages/RetirementPage.js";
import GetMoneyPage from "./pages/GetMoneyPage.js";
import LoansPage from "./pages/LoansPage.js";
import SavingPage from "./pages/SavingPage.js";
import Recommendations from "./pages/Recommendations.js";
import api from "./utils/api.js";
import { isAuthenticated } from "./utils/auth.js";
import NotFound from "./pages/404";
import { Modal, Box } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const protectedRoutes = [
  "/",
  "/summary",
  "/retirement",
  "/profile",
  "/active-insurance",
  "/finance",
  "/pension-policy",
  "/summary-page",
  "/get-money",
  "/loans",
  "/savings",
  "/recommendations",
];
const App = () => {
  const location = useLocation();
  const [showSidebarNavbar, setShowSidebarNavbar] = useState(true);
  const [data, setData] = useState();
  const [onboardingStep, setOnboardingStep] = useState(5);
  const [onboarding_error, setonboarding_error] = useState(0);
  const [loading, setLoading] = useState(false);
  const [insurancePolicies, setInsurancePolicies] = useState([]);
  const [balances, setBalances] = useState([]);
  const [pensionPolicies, setPensionPolicies] = useState([]);
  const [carrierLogos, setCarrierLogos] = useState([]);
  const [savings, setSavings] = useState([]);
  const [yieldsAll, setYieldsAll] = useState([]);
  const [insights, setInsights] = useState([]);
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [open, setOpen] = useState(false);
  const [loadingTimer, setLoadingTimer] = useState(null);
  useEffect(() => {
    let intervalId;

    const syncSession = async () => {
      try {
        await api.post(
          `${process.env.REACT_APP_BE_BASE_URL}session/session-sync`,
        );
        console.log("Session synced successfully");
      } catch (error) {
        console.error("Failed to sync session:", error);
      }
    };
    const shouldSync =
      isAuthenticated() && protectedRoutes.includes(location.pathname);
    if (shouldSync) {
      syncSession();
      intervalId = setInterval(syncSession, 1 * 60 * 1000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [location.pathname]);

  const navigate = useNavigate();
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    bgcolor: "background.paper",
    borderRadius: "16px",
    boxShadow: 24,
    height: {
      xs: "80vh",
      sm: "80vh",
      md: "80vh",
      lg: "auto",
      xl: "auto",
    },
    p: {
      xs: 4,
      sm: 6,
      md: 8,
      lg: 10,
      xl: 12,
    },
    outline: "none",
    textAlign: "center",
    direction: "rtl",
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const fetchParallelData = async () => {
    clearTimeout(loadingTimer);
    setLoading(true);
    const baseUrl = process.env.REACT_APP_BE_BASE_URL;

    const endpoints = [
      "policy/insurance-policies",
      "policy/balances",
      "policy/pension-policies",
      "policy/savings",
      "policy/yields-all",
      "user/get_user",
      "policy/insights",
      "policy/logos",
    ];
    try {
      const responses = await Promise.all(
        endpoints.map((endpoint) => api.get(`${baseUrl}${endpoint}`)),
      );
      const [
        insurancePolicies,
        balances,
        pensionPolicies,
        savings,
        yieldsAll,
        user,
        userInsights,
        logos,
      ] = responses.map((res) => res.data);
      setData(user?.data);
      setOnboardingStep(user?.data?.onboarding_step);
      setOpen(
        user?.data?.onboarding_step == 1 ||
          user?.data?.onboarding_step == "1" ||
          user?.data?.onboarding_step == 2 ||
          user?.data?.onboarding_step == "2"
          ? true
          : false,
      );
      setonboarding_error(user?.data?.onboarding_error);
      setYieldsAll(yieldsAll.data);
      setSavings(savings.data);
      setPensionPolicies(pensionPolicies.data);
      setBalances(balances.data);
      setInsurancePolicies(insurancePolicies.data);
      setInsights(userInsights.data);
      setCarrierLogos(logos.data);

      setHasFetchedData(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   api.post("/user/update_onboarding_step", {
  //     email: "malul@productive.co.il",
  //     onboarding_step: 2,
  //   });
  // }, []);

  useEffect(() => {
    const privateRoutes = [
      "/",
      "/summary",
      "/retirement",
      "/profile",
      "/active-insurance",
      "/finance",
      "/pension-policy",
      "/summary-page",
      "/get-money",
      "/loans",
      "/savings",
      "/recommendations",
    ];
    const excludedPaths = [
      "/otp",
      "/login-success",
      "/register",
      "/user-info",
      "/user-info-about",
      "/document-upload",
      "/user-signature",
      "/login",
      "/register",
    ];
    setShowSidebarNavbar(!excludedPaths.includes(location.pathname));

    if (
      isAuthenticated() &&
      privateRoutes.includes(location.pathname) &&
      !hasFetchedData
    ) {
      setTimeout(() => {
        setLoading(true);
      }, 200);
      fetchParallelData();
    } else {
      setLoadingTimer(
        setTimeout(() => {
          setLoading(false);
        }, 1000),
      );
    }
  }, [location.pathname, isAuthenticated()]);

  // const copyReferralLink = () => {
  //   if (data?._id) {
  //     const formattedId = data._id;
  //     const referalLink = `${window.location.origin}/register?step=1&REFERBY=${formattedId}`;
  //     console.log(referalLink);
  //     navigator.clipboard.writeText(referalLink);
  //     toast.success("Referral link copied to clipboard");
  //   }
  // };

  const Wrapper = showSidebarNavbar ? "div" : React.Fragment;
  return (
    <>
      {!loading ? (
        <div className={showSidebarNavbar ? `dashboard` : "login_dashboard"}>
          {showSidebarNavbar && <Sidebar />}
          <Wrapper
            {...(showSidebarNavbar ? { className: "main-content" } : {})}
          >
            {showSidebarNavbar && data && (
              <Navbar
                setHasFetchedData={setHasFetchedData}
                data={data}
                // copyReferralLink={copyReferralLink}
              />
            )}
            <Wrapper
              {...(showSidebarNavbar
                ? { className: "main d-flex flex-column gap-36" }
                : {})}
            >
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/otp" element={<LoginScreenOne />} />
                <Route path="/login-success" element={<LoginScreenTwo />} />
                <Route path="/register" element={<SignUp />} />

                {/* Protected Routes */}
                <Route
                  path="/"
                  element={
                    <PrivateRoute
                      element={
                        <SummaryPage
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          data={data}
                          yieldsAll={yieldsAll}
                          savings={savings}
                          pensionPolicies={pensionPolicies}
                          balances={balances}
                          insurancePolicies={insurancePolicies}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/summary"
                  element={<PrivateRoute element={<Summery />} />}
                />
                <Route
                  path="/retirement"
                  element={
                    <PrivateRoute
                      element={
                        <RetirementPage
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          data={data}
                          yieldsAll={yieldsAll}
                          savings={savings}
                          pensionPolicies={pensionPolicies}
                          balances={balances}
                          insurancePolicies={insurancePolicies}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <PrivateRoute
                      element={
                        <ProfilePage pensionPolicies={pensionPolicies} />
                      }
                    />
                  }
                />
                <Route
                  path="/active-insurance"
                  element={
                    <PrivateRoute
                      element={
                        <ActiveInsurence
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          data={data}
                          insurancePolicies={insurancePolicies}
                          carrierLogos={carrierLogos || []}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/finance"
                  element={
                    <PrivateRoute
                      element={
                        <FinancePension
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          data={data}
                          yieldsAll={yieldsAll}
                          savings={savings}
                          pensionPolicies={pensionPolicies}
                          balances={balances}
                          insurancePolicies={insurancePolicies}
                          carrierLogos={carrierLogos || []}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/pension-policy"
                  element={
                    <PrivateRoute
                      element={
                        <FinancePensionWithChart
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          data={data}
                          yieldsAll={yieldsAll}
                          savings={savings}
                          pensionPolicies={pensionPolicies}
                          balances={balances}
                          insurancePolicies={insurancePolicies}
                          carrierLogos={carrierLogos || []}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/summary-page"
                  element={
                    <PrivateRoute
                      element={
                        <SummaryPage
                          data={data}
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          yieldsAll={yieldsAll}
                          savings={savings}
                          pensionPolicies={pensionPolicies}
                          balances={balances}
                          insurancePolicies={insurancePolicies}
                          carrierLogos={carrierLogos || []}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/loading"
                  element={
                    <PrivateRoute
                      element={
                        <LoadingPage
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/get-money"
                  element={<PrivateRoute element={<GetMoneyPage />} />}
                />
                <Route
                  path="/loans"
                  element={
                    <PrivateRoute
                      element={
                        <LoansPage
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          data={data}
                          yieldsAll={yieldsAll}
                          savings={savings}
                          pensionPolicies={pensionPolicies}
                          balances={balances}
                          insurancePolicies={insurancePolicies}
                          carrierLogos={carrierLogos || []}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/savings"
                  element={
                    <PrivateRoute
                      element={
                        <SavingPage
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          data={data}
                          yieldsAll={yieldsAll}
                          savings={savings}
                          pensionPolicies={pensionPolicies}
                          balances={balances}
                          insurancePolicies={insurancePolicies}
                          carrierLogos={carrierLogos || []}
                        />
                      }
                    />
                  }
                />
                <Route
                  path="/recommendations"
                  element={
                    <PrivateRoute
                      element={
                        <Recommendations
                          onboardingStep={onboardingStep}
                          onboarding_error={onboarding_error}
                          data={data}
                          yieldsAll={yieldsAll}
                          savings={savings}
                          pensionPolicies={pensionPolicies}
                          balances={balances}
                          insurancePolicies={insurancePolicies}
                          insights={insights}
                          carrierLogos={carrierLogos || []}
                        />
                      }
                    />
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Wrapper>
          </Wrapper>
          <Modal open={open} onClose={handleClose}>
            <Box sx={modalStyle}>
              <div className="registration-success">
                <h2 className="registration-title" st>
                  ממתינים
                </h2>
                <div className="registration-text">
                  <p>
                    <b>עדיין לא התקבל מידע במערכת שלנו.</b>
                  </p>
                  <p>
                    בעוד כ-48 שעות מרגע ההרשמה תהיה לנו תמונת מצב מלאה לגבי כל
                    אחד מהמוצרים הפיננסים שלכם. אנחנו נציג את המידע באזור האישי
                    שלכם במגוון דאשבורים ודוחות מפורטים. את המידע תוכלו לקבל גם
                    בתצורה של דוח למייל או לוואטסאפ.
                  </p>
                  <p>נרשמתם והמידע עדיין לא מופיע? </p>
                  <p>
                    זה בסדר, לוקח לנו כ-48 שעות לאסוף את המידע ולנתח אותו. אתם
                    לא
                    <br />
                    צריכים לחכות, אנחנו נודיע לכם מיד בקבלת המידע.{" "}
                  </p>
                  <p>
                    עברו יותר מ48 שעות והמידע עדין לא התקבל?
                    <br />
                    כנראה שיש בעיה בנתונים שהזנתם, מוזמנים לבדוק שוב ולתקן במידת
                    הצורך
                    <br />
                    <Link to="/profile">עדכון נתונים</Link>
                  </p>
                  <p>
                    <b>
                      עד שנהיה מוכנים, אתם מוזמנים לקבל מידע וכלים פיננסים
                      בפורטל ,שלנו שם תמצאו מדריכים פיננסים, כתבות, פודקאסטים
                      וכל מה שצריך לדעת כדי לעשות יותר עם הכסף שלכם במידת הצורך
                    </b>
                  </p>
                </div>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  {/* <button className="btn-m btn-primary" onClick={handleClose}>
                    לאזור האישי
                  </button> */}
                  <button
                    className="btn-m btn-outline"
                    onClick={() => {
                      navigate("/");
                      handleClose();
                    }}
                  >
                    קחו אותי לפורטל
                  </button>
                </Box>
              </div>
            </Box>
          </Modal>
        </div>
      ) : (
        <div className="dashboard">
          <Sidebar />
          <Wrapper className="main-content">
            <Wrapper className="main d-flex flex-column gap-36">
              <LoadingPage />
            </Wrapper>
          </Wrapper>
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
    </>
  );
};

export default App;
